import React, { useRef, useState } from 'react';
import html2pdf from 'html2pdf.js';
import { savePDFForm } from './supabaseService';

const LOGO_URL = '/logo.jpg';

const sectionDefs = [
  {
    key: 'kitchen',
    title: 'KITCHEN AREA',
    items: [
      ['workTops', 'Work Tops Clean'],
      ['floors', 'Floors Clean'],
      ['sink', 'Sink Clean'],
      ['frontCupboards', 'Front Cupboards Clean'],
      ['insideCupboards', 'Inside Cupboards Clean'],
      ['oven', 'Oven Clean'],
      ['walls', 'Walls Clean'],
      ['skirtingBoards', 'Skirting Boards Clean'],
      ['windows', 'Windows Clean'],
      ['accessories', 'Accessories Clean'],
      ['ceilingLights', 'Ceiling Lights Clean'],
      ['radiator', 'Radiator Clean'],
      ['chairsTable', 'Chairs / Table Clean'],
      ['fridgeOutside', 'Fridge Outside Clean'],
      ['fridgeInside', 'Fridge Inside Clean'],
      ['splashBack', 'Splash Back Clean'],
    ],
  },
  {
    key: 'bathrooms',
    title: 'BATHROOMS',
    items: [
      ['men', 'Men'],
      ['women', 'Women'],
      ['disabled', 'Disabled'],
      ['offensiveOdor', 'Offensive Odor'],
      ['accessories', 'Accessories Clean'],
      ['ceilingLights', 'Ceiling Lights Clean'],
      ['radiator', 'Radiator Clean'],
      ['showerScreen', 'Shower / Screen Clean'],
      ['floors', 'Floors Clean'],
      ['walls', 'Walls Clean'],
      ['handBasin', 'Hand Basin / Tap / Mirror Clean'],
      ['toiletBowl', 'Toilet Bowl Clean'],
      ['urinals', 'Urinals Clean'],
      ['binEmptied', 'Bin Emptied'],
    ],
  },
  {
    key: 'office',
    title: 'OFFICE AREA / STOREROOM',
    items: [
      ['desks', 'Desks Clean'],
      ['monitors', 'Monitors Clean'],
      ['furniture', 'Furniture Clean'],
      ['carpet', 'Carpet Clean'],
      ['skirtingBoards', 'Skirting Boards / Ledges Clean'],
      ['binsEmptied', 'Bins Emptied'],
      ['windows', 'Windows Clean'],
      ['telephone', 'Telephone'],
    ],
  },
];

const initialState = {
  kitchen: {
    workTops: 'Yes', floors: 'Yes', sink: 'Yes', frontCupboards: 'Yes', insideCupboards: 'Yes', oven: 'Yes', walls: 'Yes', skirtingBoards: 'Yes', windows: 'Yes', accessories: 'Yes', ceilingLights: 'Yes', radiator: 'Yes', chairsTable: 'Yes', fridgeOutside: 'Yes', fridgeInside: 'Yes', splashBack: 'Yes',
    recommendations: '',
  },
  bathrooms: {
    men: 'Yes', women: 'Yes', disabled: 'Yes', offensiveOdor: 'Yes', accessories: 'Yes', ceilingLights: 'Yes', radiator: 'Yes', showerScreen: 'Yes', floors: 'Yes', walls: 'Yes', handBasin: 'Yes', toiletBowl: 'Yes', urinals: 'Yes', binEmptied: 'Yes',
    recommendations: '',
  },
  office: {
    desks: 'Yes', monitors: 'Yes', furniture: 'Yes', carpet: 'Yes', skirtingBoards: 'Yes', binsEmptied: 'Yes', windows: 'Yes', telephone: 'Yes',
    recommendations: '',
  },
  department: '',
  contactInfo: '',
};

const styles = {
  container: {
    maxWidth: 700,
    margin: '40px auto',
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
    padding: 24,
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  title: {
    textAlign: 'center',
    fontSize: 28,
    fontWeight: 800,
    color: '#b00',
    marginBottom: 8,
    letterSpacing: 1,
  },
  subtitle: {
    textAlign: 'center',
    fontSize: 16,
    color: '#222',
    marginBottom: 18,
    fontWeight: 500,
  },
  checklistItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 0',
    borderBottom: '1px solid #eee',
    fontSize: 16,
  },
  label: {
    fontWeight: 600,
    fontSize: 15,
    color: '#b00',
    marginBottom: 2,
  },
  radioGroup: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: 15,
    border: '1.5px solid #b00',
    borderRadius: 8,
    background: '#fff',
    color: '#222',
    marginBottom: 0,
    boxSizing: 'border-box',
  },
  textarea: {
    width: '100%',
    minHeight: 60,
    padding: '10px 12px',
    fontSize: 15,
    border: '1.5px solid #b00',
    borderRadius: 8,
    background: '#fff',
    color: '#222',
    resize: 'vertical',
    marginBottom: 0,
  },
  button: {
    display: 'block',
    margin: '32px auto 0',
    padding: '12px 36px',
    fontSize: 18,
    fontWeight: 600,
    color: '#fff',
    background: 'linear-gradient(90deg, #b00 0%, #222 100%)',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(176,0,0,0.08)',
    transition: 'background 0.2s',
  },
  logo: {
    width: 90,
    height: 'auto',
    display: 'block',
    margin: '24px auto 0',
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  section: {
    marginBottom: 24,
    border: '1px solid #eee',
    borderRadius: 8,
    padding: 16,
  },
  sectionTitle: {
    fontWeight: 'bold',
    fontSize: 18,
    marginBottom: 12,
    color: '#b00',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: 12,
  },
  th: {
    background: '#f2f2f2',
    fontWeight: 700,
    padding: 8,
    border: '1px solid #ccc',
    textAlign: 'left',
    fontSize: 14,
  },
  td: {
    border: '1px solid #e0e0e0',
    padding: 8,
    fontSize: 14,
    background: '#fff',
  },
  select: {
    width: '100%',
    padding: '8px',
    fontSize: 14,
    borderRadius: 4,
    border: '1px solid #ccc',
    background: '#fff',
    boxSizing: 'border-box',
  },
};

export default function KensiteChecklist() {
  const [form, setForm] = useState(initialState);
  const [date, setDate] = useState('');
  const [staffName, setStaffName] = useState('');
  const [comments, setComments] = useState({
    kitchen: '',
    bathrooms: '',
    office: ''
  });

  const handleInput = (section, key, value) => {
    setForm((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [key]: value,
      },
    }));
  };

  const handleText = (section, value) => {
    setForm((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        recommendations: value,
      },
    }));
  };



  const generatePDF = async () => {
    try {
      const pdfHtml = `
        <div style="font-family: 'Segoe UI', Arial, sans-serif; background: #fff; padding: 0; margin: 0;">
          <div style="background: linear-gradient(90deg, #b00 0%, #222 100%); padding: 18px 0 12px 0; text-align: center; border-radius: 0 0 18px 18px; box-shadow: 0 2px 12px rgba(176,0,0,0.10);">
            <div style='font-size: 30px; font-weight: 900; color: #fff; letter-spacing: 1.2px; margin-bottom: 2px;'>Kensite Checklist</div>
            <div style='font-size: 18px; color: #fff; font-weight: 500; margin-top: 8px;'>Date: ${date || '<span style="color:#eee">(No date)</span>'} &nbsp; | &nbsp; Staff: ${staffName || '<span style="color:#eee">(No name)</span>'}</div>
          </div>
          <div style="padding: 24px;">
            ${sectionDefs.map((section, idx) => `
              <div style='margin-bottom: 32px; background: #fafbfc; border-radius: 12px; padding: 20px; border: 1.5px solid #eee;'>
                <div style='font-size: 20px; font-weight: 700; color: #b00; margin-bottom: 16px; border-bottom: 2px solid #b00; padding-bottom: 8px;'>${section.title}</div>
                <table style='width: 100%; border-collapse: collapse; font-size: 16px; margin-top: 4px;'>
                  <thead>
                    <tr style='background: #b00;'>
                      <th style='padding: 10px 8px; color: #fff; font-size: 15px; font-weight: 700; border-bottom: 2px solid #222;'>Task</th>
                      <th style='padding: 10px 8px; color: #fff; font-size: 15px; font-weight: 700; border-bottom: 2px solid #222;'>Completed</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${section.items.map(([key, label], i) => `
                      <tr style='background: ${i%2===0 ? '#fff' : '#f6f6f6'};'>
                        <td style='padding: 10px 8px; color: #222; border-bottom: 1px solid #eee; font-weight: 500;'>${label}</td>
                        <td style='text-align: center; padding: 10px 8px; border-bottom: 1px solid #eee; font-size: 20px; font-weight: 700; color: ${form[section.key][key] ? '#b00' : '#111'};'>${form[section.key][key] ? '<span style="font-size:22px; color:#b00;">✔️</span>' : '<span style="font-size:22px; color:#111;">✖️</span>'}</td>
                      </tr>
                    `).join('')}
                  </tbody>
                </table>
                <div style='margin-top: 24px;'>
                  <div style='font-size: 15px; font-weight: 600; color: #b00; margin-bottom: 6px;'>Comments:</div>
                  <div style='min-height: 48px; border: 1.5px solid #b00; border-radius: 8px; background: #fafbfc; padding: 10px 12px; font-size: 15px; color: #222;'>${comments[section.key] || '<span style="color:#bbb;">(No comments)</span>'}</div>
                </div>
              </div>
            `).join('')}
            <img src='${LOGO_URL}' alt='Logo' style='width: 90px; height: auto; border-radius: 12px; box-shadow: 0 1px 4px rgba(0,0,0,0.08); display:block; margin: 32px auto 0 auto;' />
          </div>
        </div>
      `;

      // Generate PDF as blob
      const pdfBlob = await html2pdf()
        .set({
          margin: 0,
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
        })
        .from(pdfHtml)
        .outputPdf('blob');

      // Create filename with form name + date
      const currentDate = new Date().toISOString().split('T')[0];
      const fileName = `Kensite_Checklist_${currentDate}.pdf`;

      // Save to Firebase
      const formData = {
        formType: 'kensite',
        title: 'Kensite Checklist',
        location: 'Not specified',
        createdBy: staffName || 'Not specified',
        date: date || currentDate,
        staffName: staffName || 'Not specified',
        formData: form,
        comments: comments
      };

      await savePDFForm(formData, pdfBlob, fileName);
      
      // Also download locally for user convenience
      const url = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      alert('PDF saved to library and downloaded successfully!');
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Error generating PDF. Please try again.');
    }
  };

  // Mobile styles
  const mobileStyle = `
    @media (max-width: 600px) {
      .kensite-container { padding: 0 !important; border-radius: 0 !important; box-shadow: none !important; background: #f6f7fb !important; }
      .kensite-title { font-size: 1.3rem !important; }
      .kensite-checklistItem { padding: 10px 4px !important; border-radius: 8px !important; }
      .kensite-label { font-size: 13px !important; }
      .kensite-input, .kensite-textarea { font-size: 15px !important; padding: 8px !important; border-radius: 8px !important; width: 100% !important; min-width: 0 !important; max-width: 100vw !important; }
      .kensite-button { font-size: 16px !important; padding: 12px 0 !important; border-radius: 10px !important; max-width: 100vw !important; }
    }
  `;

  return (
    <div style={styles.container} className="kensite-container">
      <style>{mobileStyle}</style>
      <div style={styles.title} className="kensite-title">Kensite Cleaning Checklist</div>
      <div style={styles.subtitle}>Please complete the checklist below. All items require a Yes/No answer. Add comments at the end if needed.</div>
      
      <div style={{ marginBottom: 18 }}>
        <div style={styles.label}>Date:</div>
        <input
          style={styles.input}
          className="kensite-input"
          type="date"
          value={date}
          onChange={e => setDate(e.target.value)}
        />
      </div>
      
      <div style={{ marginBottom: 18 }}>
        <div style={styles.label}>Staff Name:</div>
        <input
          style={styles.input}
          className="kensite-input"
          type="text"
          value={staffName}
          onChange={e => setStaffName(e.target.value)}
          placeholder="Enter your name..."
        />
      </div>

      <div style={{ marginBottom: 18 }}>
        <div style={styles.label}>Department/Location:</div>
        <input
          style={styles.input}
          className="kensite-input"
          type="text"
          value={form.department}
          onChange={e => setForm(prev => ({ ...prev, department: e.target.value }))}
          placeholder="Enter department/location..."
        />
      </div>

      {sectionDefs.map(section => (
        <div key={section.key} style={styles.section} className="kensite-section">
          <div style={styles.sectionTitle}>{section.title}</div>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Item</th>
                <th style={styles.th}>Yes</th>
                <th style={styles.th}>No</th>
              </tr>
            </thead>
            <tbody>
              {section.items.map(([key, label]) => (
                <tr key={key}>
                  <td style={styles.td}>{label}</td>
                  <td style={styles.td}>
                    <input
                      type="radio"
                      name={`${section.key}-${key}`}
                      value="Yes"
                      checked={form[section.key][key] === 'Yes'}
                      onChange={() => handleInput(section.key, key, 'Yes')}
                    />
                  </td>
                  <td style={styles.td}>
                    <input
                      type="radio"
                      name={`${section.key}-${key}`}
                      value="No"
                      checked={form[section.key][key] === 'No'}
                      onChange={() => handleInput(section.key, key, 'No')}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ marginTop: 12 }}>
            <div style={styles.label}>Recommendations:</div>
            <textarea
              style={styles.textarea}
              className="kensite-textarea"
              value={form[section.key].recommendations}
              onChange={e => handleText(section.key, e.target.value)}
              placeholder="Add recommendations for this section..."
            />
          </div>
          <div style={{ marginTop: 12 }}>
            <div style={styles.label}>Comments:</div>
            <textarea
              style={styles.textarea}
              className="kensite-textarea"
              value={comments[section.key]}
              onChange={e => setComments(prev => ({ ...prev, [section.key]: e.target.value }))}
              placeholder="Add comments for this section..."
            />
          </div>
        </div>
      ))}



      <button style={styles.button} className="kensite-button" onClick={generatePDF}>Download PDF</button>
      <img src="/logo.jpg" alt="Logo" style={styles.logo} />
    </div>
  );
}
